"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleRecaptcha = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const baseLibrary_1 = require("../baseLibrary");
class MbGoogleRecaptcha extends baseLibrary_1.BaseLibrary {
    async load(key) {
        const captchaKey = key ?? window.RECAPTCHA_SITE_KEY;
        if (captchaKey && captchaKey.trim()) {
            this.instance = new web_ui_framework_1.GoogleRecaptcha(captchaKey);
            await this.instance.load();
        }
        else {
            web_ui_framework_1.Log.warn('GoogleRecaptcha: There is no valid RECAPTCHA_SITE_KEY configured');
        }
    }
}
const GoogleRecaptcha = new MbGoogleRecaptcha();
exports.GoogleRecaptcha = GoogleRecaptcha;
//# sourceMappingURL=index.js.map